import { getProductSubcategoryListData } from '../productSubcategories/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { IEntitySelectItem, TEntityId } from '~/types/models'
import type {
  IProductCategory,
  IProductCategoryOverview,
  IProductSubcategory,
} from '~/types/product/models'

const productCategoryListData = undefined as unknown as IProductCategory[]

export const getProductCategoryListData = getListDataFunctionFactory<
  IProductCategory[]
>({
  listData: productCategoryListData,
  storageKey: 'productcategories',
  getStartingListData: getStartingProductCategoryListData,
})

export function _getPRCDataById(
  id: TEntityId,
  list: IProductCategory[]
): IProductCategory {
  if (!list) {
    throw new Error(`_getPRCDataById called with undefined/null list`)
  }
  const productCategory = list.find((p: IProductCategory) => p.id === id)
  if (!productCategory) {
    throw new Error(`Can't find productCategory '${id}'`)
  }
  return productCategory
}

export async function getProductCategoryDataById(
  id: string
): Promise<IProductCategory> {
  const list: IProductCategory[] = await getProductCategoryListData()
  return _getPRCDataById(id, list)
}

export function _getPRCSelectItemDataById(
  id: TEntityId,
  list: IProductCategory[]
): IEntitySelectItem {
  if (!list) {
    throw new Error(`_getPRCSelectItemDataById called with undefined/null list`)
  }
  const productCategory = _getPRCDataById(id, list)
  return { id: productCategory.id, label: productCategory.descr }
}

export async function getProductCategorySelectDataById(
  id: string
): Promise<IEntitySelectItem> {
  const pc = await getProductCategoryDataById(id)
  return { id: pc.id, label: pc.descr }
}

export async function getProductSubcategoriesData(
  id: string
): Promise<IProductSubcategory[] | undefined> {
  const list = await getProductSubcategoryListData()
  return list.filter(
    (productSubcategory: IProductSubcategory) =>
      productSubcategory.productCategory.id === id
  )
}

export async function getProductCategoryOverviewData(
  id: string
): Promise<IProductCategoryOverview | undefined> {
  const list = await getProductCategoryListData()
  const productCategoryData = list.find(
    (productCategory: IProductCategory) => productCategory.id === id
  )
  if (!productCategoryData) {
    return undefined
  }
  const productSubcategoriesData = (await getProductSubcategoriesData(id)) || []
  const overviewData = {
    productCategory: productCategoryData,
    productSubcategories: productSubcategoriesData,
  }
  console.debug(overviewData)
  return overviewData
}

export async function getStartingProductCategoryListData(): Promise<
  IProductCategory[]
> {
  return [
    {
      id: 'XXPRC0001',
      hrid: 'PRC0001',
      descr: 'Connectivity',
      numItems: 3,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRC0002',
      hrid: 'PRC0002',
      descr: 'Voice & Collaboration',
      numItems: 1,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRC0003',
      hrid: 'PRC0003',
      descr: 'Services',
      numItems: 2,
      version: '1',
      canBeDeleted: false,
    },
  ]
}
